<script type="text/javascript">
	import { createEventDispatcher } from "svelte"

	import FilterPropertyType from "./FilterPropertyType";
	import FilterPropertyRenderType from "./FilterPropertyRenderType";
	import FilterOperator from "./FilterOperator";
	import Filters from "./Filters";

	import { generateHoursInAMonthWindow } from "../Helpers/Misc/timeHelper";
	import FlagHelper from "../Helpers/FlagHelper";

	import Select, {Option} from '@smui/select';

	let relativeTimeOptions = generateHoursInAMonthWindow();

	const dispatch = createEventDispatcher(); // update

	export let name = "default";
	export let filters;

	let lastUpdated = filters.lastUpdated;
	$: {
		$lastUpdated
		dispatch("update");
	}
</script>

<div>
	{#if filters.length === 0}
		<div class='condition-sets-empty'>Click '+' to add advanced filters.</div>
	{/if}

	{#each filters.sets as set, setIndex}
		<div class='condition-set'>
			<div class='condition-set-titlearea'>
				<h2 style='display:inline-block'>Condition Set #{setIndex+1}:</h2>
				<button class='btn-sml bg-error' on:click={()=>{ filters.removeSet(set); }}>delete</button>
				{#if filters.multisetEnabled}
					<button class='btn-sml bg-info' on:click={()=>{ filters.duplicateSet(set); }}>duplicate</button>
				{/if}
			</div>

			<table class='condition-set-table'>
				<thead>
					<tr>
						<th width="33%">Property</th>
						<th width="33%">Operator</th>
						<th width="33%">Value</th>
					</tr>
				</thead>
				<tbody>
					{#each set.clauses as clause, index}
						<tr>
							<td>
								<select bind:value={clause.property} on:change={()=>{
									set.addOrRemoveClauseIfNecessary();
									let next = document.getElementById("filter-"+setIndex+"-clause-operator-"+name+"-"+index);
									if (next) { next.focus(); }
								}}>
									<option value="" selected="true">Select:</option>
									{#each filters.properties as property}
										<option value={property.key}>{property.name}</option>
									{/each}
								</select>
							</td>
							<td>
								{#if clause.property !== ""}
									<select id={"filter-"+setIndex+"-clause-operator-"+name+"-"+index} bind:value={clause.operator} on:change={(e)=>{
										filters.onChange();

										let next = document.getElementById("filter-"+setIndex+"-clause-value-"+name+"-"+index);
										if (next) { next.focus(); }
									}}>
										{#if filters.propertiesKeyed[clause.property].operators.length > 1}
											<option value="" selected="true">Select:</option>
										{/if}

										{#each filters.propertiesKeyed[clause.property].operators as operator}
											<option value={operator}>
												{#if filters.propertiesKeyed[clause.property].operatorAliases && typeof filters.propertiesKeyed[clause.property].operatorAliases[operator] !== "undefined"}
													{filters.propertiesKeyed[clause.property].operatorAliases[operator]}
												{:else}
													{operator}
												{/if}
											</option>
										{/each}
									</select>
								{/if}
							</td>
							<td>
								{#if clause.property !== ""}
									{#if filters.propertiesKeyed[clause.property].type === FilterPropertyType.ENUM}

										<!--
											Advanced filter doesn't render on the right layer.
										<Select enhanced bind:value={clause.value} on:change={()=>{ filters.onChange() }} label="" class="" menu$class="">
											<Option value="" selected="true">Select:</Option>
											{#each filters.propertiesKeyed[clause.property].typeData.options as option}
												<Option value={option} selected={clause.value === option}>{option}</Option>
											{/each}
										</Select> -->

										<select id={"filter-"+setIndex+"-clause-value-"+name+"-"+index} bind:value={clause.value} on:change={()=>{filters.onChange()}}>
											<option value="" selected="true">Select:</option>
											{#each filters.propertiesKeyed[clause.property].typeData.options as option}
												<option value={option} class={"flag flag-"+FlagHelper.toFlagCountryCode(option)}>
													{option}
													{#if filters.propertiesKeyed[clause.property].typeData.renderType === FilterPropertyRenderType.FLAG && FlagHelper.isValidFlag(option)}
														&nbsp;({FlagHelper.toFlagCountryName(option)})
													{/if}
												</option>
											{/each}
										</select>
									{:else if filters.propertiesKeyed[clause.property].type === FilterPropertyType.RELATIVE_TIME}
										<select id={"filter-"+setIndex+"-clause-value-"+name+"-"+index} bind:value={clause.value} on:change={()=>{filters.onChange()}}>
											{#each relativeTimeOptions as option}
												<option value={option.value}>
													{#if option.num == 0}
														now
													{:else}
														{option.num} {option.unit}{#if option.num != 1}s{/if}
														{#if option.value > 0} from now
														{:else if option.value < 0} in the past
														{/if}
													{/if}
												</option>
											{/each}
										</select>
									{:else if (filters.propertiesKeyed[clause.property].type === FilterPropertyType.STRING || filters.propertiesKeyed[clause.property].type === FilterPropertyType.NUMBER)}
										<input id={"filter-"+setIndex+"-clause-value-"+name+"-"+index} type='text' bind:value={clause.value} on:change={()=>{filters.onChange()}} on:keyup={()=>{filters.onChange()}}/>
									{/if}
								{/if}
							</td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>
	{/each}
</div>
